import React, { useState, useEffect } from 'react';
import CardComponent from './card';
import VehicleTable from './VehicleTable';
import { GetFromApi } from '../utils/api';
import socketService from '../utils/socket';
import { Spinner } from 'react-bootstrap';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [vehicles, setVehicles] = useState([]);

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const vehiclesResponse = await GetFromApi('/dashboard/vehicles');
      if (vehiclesResponse.success) {
        // Transform data for VehicleTable format
        const formattedVehicles = vehiclesResponse.data.map(v => ({
          ...v,
          vehicle: v.number,
          date: new Date().toLocaleDateString(),
          dateTime: v.lastUpdate ? new Date(v.lastUpdate).toLocaleString() : new Date().toLocaleString(),
          location: v.address || 'Unknown',
          pos: v.lat && v.lng ? 'Fixed' : 'Unknown',
          igntime: v.ignition ? 'ON' : 'OFF',
          network: 'Online',
          gps: 'Fixed',
          intVolt: v.int_voltage ? `${parseFloat(v.int_voltage).toFixed(1)}V` : '0.0V',
          extVolt: v.ext_voltage ? `${parseFloat(v.ext_voltage).toFixed(1)}V` : '0.0V',
          distance: `${parseFloat(v.odometer || 0).toFixed(1)} Km`
        }));
        setVehicles(formattedVehicles);
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicles();

    // Subscribe to real-time updates
    socketService.connect();
    socketService.on('vehicle:location', (data) => {
      setVehicles(prev => prev.map(v => 
        v.id === data.vehicleId ? { 
          ...v, 
          speed: data.speed, 
          lat: data.lat, 
          lng: data.lng,
          status: data.isMoving !== undefined ? (data.isMoving ? 'running' : 'stopped') : (data.speed > 3 ? 'running' : 'stopped'),
          dateTime: new Date().toLocaleString()
        } : v
      ));
    });

    return () => {
      socketService.off('vehicle:location');
    };
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <Spinner animation="border" variant="primary" />
        <span className="ms-3">Loading dashboard...</span>
      </div>
    );
  }

  return (
    <div className="container-fluid p-3">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mb-0">Dashboard</h4>
        <button className="btn btn-light" onClick={fetchVehicles}>
          <i className="fa fa-sync me-2"></i> Refresh
        </button>
      </div>
      
      {/* Use the user's existing CardComponent */}
      <CardComponent vehicles={vehicles} loading={loading} />
      
      <div className="row mt-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
              <h6 className="mb-0 fw-semibold">Vehicle Status</h6>
              <span className="text-muted small">Real-time updates enabled</span>
            </div>
            <div className="card-body p-0">
              <VehicleTable data={vehicles} vehicles={vehicles} refreshData={fetchVehicles} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;